<template>
  <div ref="rootRef" class="ckeditor-resizable">
    <slot />
    <div
      class="ckeditor-resizable__handle"
      title="Потяните, чтобы изменить высоту редактора"
      @mousedown.prevent="startResize"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import { useCkeditorResize } from '@/composables/useCkeditorResize.js'

/** Обёртка CKEditor с ручкой изменения высоты снизу */
export default {
  name: 'CkeditorResizable',
  props: {
    defaultHeight: {
      type: Number,
      default: 300
    },
    minHeight: {
      type: Number,
      default: 120
    }
  },
  setup (props) {
    const rootRef = ref(null)
    const { startResize } = useCkeditorResize(rootRef, {
      defaultHeight: props.defaultHeight,
      minHeight: props.minHeight
    })

    return { rootRef, startResize }
  }
}
</script>

<style lang="scss" scoped>
.ckeditor-resizable {
  position: relative;

  &__handle {
    height: 12px;
    cursor: ns-resize;
    border: 1px solid #000;
    border-top: none;
    border-radius: 0 0 6px 6px;
    background: #f0f0f0;
    transition: background 0.2s;

    &::after {
      content: '';
      display: block;
      width: 36px;
      height: 4px;
      margin: 3px auto 0;
      border-radius: 2px;
      background: #888;
    }

    &:hover {
      background: #e0f4fc;
    }
  }
}
</style>
